<template>
    <div class="login-box">
        <em class="logo ng-scope"></em>
        <div v-if="isValidToken === null" class="col col-md-6 my-auto login-text">
            <img src="static/img/loader.gif" style="max-width:100px;"/>
        </div>
        <div v-else class="col col-md-6 my-auto login-text">
            <div v-if="!isValidToken" class="">
                <h3 class="centered">Invalid or Expired Token</h3>
            </div>
            <div v-if="isValidToken" class="">
                <h3>Reset Your Password</h3>
                <p v-if="!isPasswordReset">(Minimum 8 characters, Maximum 50, 1 uppercase, 1 lowercase, 1 number, and 1 special character)</p>
            </div>
            <div v-if="!isValidToken" class="centered">
                <p>We're sorry, but the link you clicked to get here could not be verified. Please click below to return to the sign in page, and use the 'forgot password' button to reset your password.</p>
            </div>
            <div class="">
                <div class="fields" v-if="isValidToken && !isPasswordReset">
                    <div class="line-item">
                        <md-field :md-toggle-password="false">
                            <md-input id="newPassword" v-model="newPassword" type="password" placeholder="New Password"
                                      class="login-input" @blur="touchNewPassHanlder()"></md-input>
                        </md-field>
                        <div v-if="$v.newPassword.$error" class="invalid-password">
                            Password must be valid (Minimum 8 characters, Maximum 50, 1 uppercase, 1 lowercase, 1 number, and 1 special character)
                        </div>
                    </div>
                    <div class="line-item">
                        <md-field :md-toggle-password="false">
                            <md-input id="confirmPassword" v-model="confirmPassword" type="password" placeholder="Confirm Password"
                                      class="login-input"></md-input>
                        </md-field>
                    </div>

                    <div v-if="newPassword" class="centered form-error">
                        <h4 v-if="$v.$invalid" class="red-text">Passwords must match
                            <md-icon>thumb_down</md-icon>
                        </h4>
                        <h4 v-else class="green-text">Passwords match
                            <md-icon>thumb_up</md-icon>
                        </h4>
                    </div>
                </div>
                <div v-if="resetUserPasswordVar">
                    <img src="static/img/loader.gif" style="max-width:100px;"/>
                </div>
                <div class="actions">
                    <md-button id="add-password" class="md-primary md-ink-ripple md-raised" v-if="!$v.$invalid && isValidToken && !isPasswordReset" v-on:click="resetPassword()">Reset
                        Password
                    </md-button>
                    <p class="centered" v-if="isPasswordReset">Your password has been reset. Please sign in using the link below.</p>
                </div>
            </div>
            <p class="centered">
                <a class="login-text text-center" v-on:click="returnToLogin()">Back to Sign In</a>
            </p>
        </div>
    </div>
</template>

<script type="text/javascript">
import {mapActions, mapGetters} from 'vuex';
import {required, minLength} from 'vuelidate/lib/validators';
import {validPassword, notWhitespace} from '../../includes/validations.js';

function newPassConfirmed (value) {
  return value === this.newPassword;
}

export default {
  computed: {
    ...mapGetters('user', ['getToken', 'isPasswordReset', 'isValidToken'])
  },
  data: () => ({
    token: '',
    newPassword: null,
    confirmPassword: null,
    resetUserPasswordVar: false
  }),
  methods: {
    ...mapActions('user', ['resetUserPassword', 'setToken', 'validateToken']),
    returnToLogin () {
      this.$router.push('/login');
    },
    resetPassword () {
      if (!this.$v.$invalid) {
        this.resetUserPasswordVar = true;
        this.resetUserPassword({password: this.newPassword, token: this.token}).then(() => {
          this.resetUserPasswordVar = false;
        });
      }
    },
    touchNewPassHanlder () {
      this.$v.newPassword.$touch();
    }
  },
  validations: {
    newPassword: {
      required,
      notWhitespace,
      minLength: minLength(8),
      validPassword
    },
    confirmPassword: {
      required,
      notWhitespace,
      newPassConfirmed
    }
  },
  mounted () {
    this.token = this.$route.params.id;
    this.validateToken(this.token);
  }
};
</script>

<style scoped lang="scss">
.logo {
    overflow: hidden;
    background: url(/static/img/logo.png);
    background-size: 288px 90px;
    width: 288px;
    height: 90px;
    margin: auto;
}

#add-password {
    width: 100%;
    background-color: rgb(0, 168, 202) !important;
    color: white;
}

.login-text {
    height: 0px !important;
    margin-bottom: 40px;
}

.md-icon.md-icon-font.md-icon-image.md-theme-default {
    padding-bottom: 10px !important;
}

.form-error {
    padding: 5px 0px;
    background-color: #ffffff !important;

    .red-text {
        color: red !important;

        .md-icon {
            margin-bottom: 0px;
        }
    }

    .green-text {
        color: green !important;

        .md-icon {
            margin-bottom: 7px;
        }
    }

    .md-icon {
        color: inherit !important;
        margin-left: 10px;
    }
}

.invalid-password {
    color: red;
    font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/ResetPassword.vue